import * as config from './index';
export const CONFIGURATION_MODULE = {
  entity: config.entity,
  entityClasic: config.entityClasic,
  dispatchZone: config.dispatchZone,
  dispatchType: config.dispatchType,
  entityRoute: config.entityRoute,
  dispatchRoute: config.dispatchRoute,
  shipping: config.shipping,
  storePickupShipping: config.storePickupShipping,
  securityStock: config.securityStock,
  securityStockCes: config.securityStockCes,
  dispatchDateRoute: config.dispatchDateRoute,
  entityZone: config.entityZone,
  entityZoneSpsa: config.entityZoneSpsa,
  integrationRoute: config.integrationRoute,
  carrier: config.carrier,
  approvalRange: config.approvalRange,
  exceptionalRate: config.exceptionalRate,
  settingLocation: config.settingLocation,
  listNewRoute: config.listNewRoute,
  entityCategory: config.EntityCategory,
  entityCapabilities: config.entityCapabilities,
  dispatchCapacityByDispatchType: config.dispatchCapacityByDispatchType,
  dailyDispatchCapacity: config.dailyDispatchCapacity,
  dailyPickingCapacityByAttribute: config.dailyPickingCapacityByAttribute,
  capacityByEntity: config.capacityByEntity,
  pickingCapacityByDispatchType: config.pickingCapacityByDispatchType,
  dailyDispatchCapacityFood: config.dailyDispatchCapacityFood,
  dispatchCapacityByDispatchTypeFood: config.dispatchCapacityByDispatchTypeFood,
  dispatchCapacityByEntity: config.dispatchCapacityByEntity,
  groupEntity: config.groupEntity,
  settingsDispach: config.settingsDispach,
  securityStockByHierarchy: config.securityStockByHierarchy,
  securityStockCesSPSA: config.securityStockCesSPSA,
  agoraShop: config.agoraShop,
  deliveryWindowsSettings: config.deliveryWindowsSettings,
  calculationRange: config.calculationRange,
};
